import styled from "styled-components";

export const StyledPage = styled.div`
  height: 100%;
  width: 100%;
  background-color: #fff;
`;
